import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import LoaderComponent from '@components/LoaderComponent';

const Logout = () => {
	const [loading] = useState(true);
	const navigate = useNavigate();

	useEffect(() => {
		const timer = setTimeout(() => {
			localStorage.removeItem('token');
			localStorage.removeItem('userInfo');
			localStorage.removeItem('email');
			sessionStorage.removeItem('geoLocationInfo');
			delete axios.defaults.headers.common['Authorization'];

			navigate('/login');
		}, 1000);

		return () => clearTimeout(timer);
	}, [navigate]);

	return <LoaderComponent loading={loading} />;
};

export default Logout;
